module.exports = __webpack_public_path__ + "img/arrow-outlined.2ccfcefd.svg";